import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type {
  AssignErrorLogBody,
  ErrorLogSearchOptions,
  ResolveErrorLogBody,
} from "@src/views/apps/system/error-logs/types";

export class ErrorLogService {
  async getErrorLogs(query: ErrorLogSearchOptions) {
    return apiService.get("/errorlogs", {
      params: sanitizeQueryParams(query),
    });
  }

  async getErrorLog(id: string | number) {
    return apiService.get(`/errorlogs/${id}`);
  }

  async resolveErrorLog(id: string | number, body: ResolveErrorLogBody = {}) {
    return apiService.patch(`/errorlogs/${id}/resolve`, body);
  }

  async assignErrorLog(id: string | number, body: AssignErrorLogBody) {
    return apiService.patch(`/errorlogs/${id}/assign`, body);
  }

  async getAssigneeDropdown() {
    return apiService.get("/errorlogs/assignees/dropdown");
  }
}

export const errorLogService = new ErrorLogService();
